import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\UpdateFuneralHomePartnerController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/UpdateFuneralHomePartnerController.php
* @route '/api/funeral_home_partner/{funeral_home_partner}'
*/
const UpdateFuneralHomePartnerController = (args: { funeral_home_partner: string | number | { id: string | number } } | [funeral_home_partner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateFuneralHomePartnerController.url(args, options),
    method: 'put',
})

UpdateFuneralHomePartnerController.definition = {
    methods: ["put"],
    url: '/api/funeral_home_partner/{funeral_home_partner}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\UpdateFuneralHomePartnerController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/UpdateFuneralHomePartnerController.php
* @route '/api/funeral_home_partner/{funeral_home_partner}'
*/
UpdateFuneralHomePartnerController.url = (args: { funeral_home_partner: string | number | { id: string | number } } | [funeral_home_partner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { funeral_home_partner: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { funeral_home_partner: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            funeral_home_partner: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        funeral_home_partner: typeof args.funeral_home_partner === 'object'
        ? args.funeral_home_partner.id
        : args.funeral_home_partner,
    }

    return UpdateFuneralHomePartnerController.definition.url
            .replace('{funeral_home_partner}', parsedArgs.funeral_home_partner.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\UpdateFuneralHomePartnerController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/UpdateFuneralHomePartnerController.php
* @route '/api/funeral_home_partner/{funeral_home_partner}'
*/
UpdateFuneralHomePartnerController.put = (args: { funeral_home_partner: string | number | { id: string | number } } | [funeral_home_partner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateFuneralHomePartnerController.url(args, options),
    method: 'put',
})

export default UpdateFuneralHomePartnerController